<template>
  <div class="row_start_start product_confirm">
    <!-- <div class="column_start_start size-20 shrink-0">
      <img src="@/assets/product_example_img.png" style="width: 100px; height: 100px;" />
    </div> -->
    <img v-if="productImage" :src="productImage" class="size-20 object-cover shrink-0 mr-2.5" />
    <div class="column_start_around" style="flex-grow: 1; height: 100%;">
      <div class="row_center_between" style="width: 100%;">
        <text class="title grow pr-1 w-0 text-black">{{ product.product.name }}</text>
        <div class="row_center_center">
          <text>x{{ product.quantity }}</text>
          <text @click="deleteProduct" class="button-icon text-[#666666] text-2xl ml-1.5">delete</text>
        </div>
      </div>
      <div class="row_center_start w-full flex-wrap my-1" v-if="product.isCombo && customizedText.length">
        <text>{{ displayComboSpecOptionText }}</text>
      </div>
      <div class="row_center_start w-full flex-wrap my-1" v-else-if="!product.isCombo && customizedText.length">
        <text>{{ displayProductSpecOptionText }}</text>
      </div>
      <div class="row_center_between font-base w-full">
        <p class="">{{ note ? `備註：${note}` : '' }}</p>
        <p class=" text-primary-color">${{ totalPrice }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    note() {
      return this.product.note
    },
    displayProductSpecOptionText() {
      return this.$store.getters['cart/displayProductSpecOptionText'](this.customizedText);
    },
    displayComboSpecOptionText() {
      return this.$store.getters['cart/displayComboSpecOptionText'](this.customizedText);
    },
    customizedText() {
      return this.$store.getters['cart/customizedText'](this.product);
    },
    productImage() {
      return this.$store.getters['product/getProductImageById'](this.product.id)
    },
    totalPrice() {
      return this.$store.getters['cart/productTotalPrice'](this.product);

    },
  },
  mounted() {
  },
  methods: {
    click() {
      this.$emit("click");
    },
    deleteProduct() {
      this.$emit("deleteProduct");
    },
  }
};
</script>
<style lang="scss">
.product_confirm {
  width: 100%;
  border-bottom: 1px dotted #000000;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  color: #666666;
}

.optionText {
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 3;
  // /* 限制顯示的行數 */
  // -webkit-box-orient: vertical;
  // white-space: normal;
}
</style>
